import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';

export interface UseGetAllExtractionIdsParams {
	company_id: string;
	organization_id: string;
}

const Service = DataExtractionService.getInstance();

export const useGetAllExtractionIds = (params: UseGetAllExtractionIdsParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.DATA_EXTRACTION_ALL_IDS, params],
		queryFn: async () => Service.getAllExtractionIds(params)
	});
};
